export const listingManager = {
  header: {
    title: "Listings",
    newListingTitle: "New listing",
    reorderExit: "Exit reorder mode",
    reorder: "Reorder listings",
    done: "Done",
    sort: "Sort",
    searchPlaceholder: "Search…",
    searchClear: "Clear",
    reorderHint: "Drag to change the order",
  },
  globalBtn: {
    title: "Global settings",
    sub: "Identity and new bookings · entire account",
  },
  list: {
    of: "of",
    listingSingular: "listing",
    listingPlural: "listings",
    unitSingular: "unit",
    unitPlural: "units",
    retry: "Retry",
    noResults: 'No results for "{query}"',
    viewUnits: "View units",
    loadingUnits: "Loading units…",
    refuerzaA: "Backs up {name}: it takes its channel bookings for now",
    noUnits: "No units",
    dragToMove: "Drag to move",
    unitFallback: "Unit {n}",
  },
  empty: {
    title: "Select a listing",
    sub: "Choose a listing from the left panel to manage its settings.",
  },
  create: {
    title: "New listing",
    subtitle: "Create a listing to group your units.",
    nameLabel: "Listing name",
    namePlaceholder: "E.g. Downtown Loft",
    typeLabel: "Accommodation type",
    currencyLabel: "Currency",
    currencyHint: "The currency can't be changed after the listing is created.",
    submit: "Create listing",
    nameRequired: "The name is required.",
    errorCreate: "Couldn't create the listing.",
    successCreate: "Listing created successfully.",
  },
  delete: {
    titleListing: "Delete listing",
    titleUnit: "Delete unit",
    text: "It will be removed from WACheckin. These changes can't be undone. To confirm, type the name:",
    placeholderListing: "Listing name",
    placeholderUnit: "Unit name",
    deleting: "Deleting…",
    confirm: "Delete",
    errorDelete: "Couldn't delete.",
    successListing: "Listing deleted successfully.",
    successUnit: "Unit deleted successfully.",
  },
  propertyTypes: {
    apartment: "Apartment",
    villa: "Villa",
    hotel: "Hotel",
    camping: "Camping",
  },
  propertyTypeLabels: {
    apartment: "Apartment",
    house: "House",
    villa: "Villa",
    hotel: "Hotel",
    room: "Room",
    studio: "Studio",
    fallback: "Accommodation",
  },
  toast: {
    errorLoad: "Error loading the listings.",
    orderSaved: "Order saved successfully.",
    errorOrder: "Couldn't save the order.",
    nameUpdated: "Name updated.",
    errorName: "Couldn't update the name.",
  },
  common: {
    cancel: "Cancel",
  },
  globalConfig: {
    hero: {
      title: "Global settings",
      subPre: "AI Agent settings that apply to",
      subStrong: "all your accommodations",
      subPost: ".",
    },
    waba: {
      checking: "Checking connection…",
      connected: "Connected",
      start: "Start here",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "Connect WhatsApp Business",
      checkingSub: "Checking your number's status…",
      numberPrefix: "Number",
      verified: "verified and ready to send ✓",
      pending: "pending verification",
      linked: "Your WhatsApp Business account is linked.",
      linkPrompt: "Link your number so the agent can reply to and message your guests on WhatsApp.",
      manage: "Manage",
      connect: "Connect",
    },
    sectionLabel: "General · entire account",
    badgeDefault: "AI ✨",
    requiresWaba: "Requires WhatsApp Business connected",
    notContracted: "Not included in your plan. Contact us to enable it.",
    cards: {
      general: {
        title: "General Settings",
        sub: "Agent identity and style",
      },
      newBookings: {
        title: "New Bookings",
        sub: "First contact, questions and booking link",
      },
      voiceAgent: {
        title: "Voice AI Agent",
        sub: "Answers phone calls",
        badge: "NEW",
      },
    },
    foot: {
      pre: "These settings are",
      strong: "unique to your account",
      post: ": changing them here applies them automatically to all listings. The rest of the configuration (check-in, access, pricing…) stays per listing.",
    },
  },
};
